import { BaseSearchParametersModel } from "../../../models/base-search-parameters.model";

import { SearchFiltersModel } from "./search-filters.model";

export class MarketplaceSearchParametersModel extends BaseSearchParametersModel {
    // public filters: SearchFiltersModel;

    public categories: Array<string>;
    public areas: Array<string>;

    public minPrice: string;
    public maxPrice: string;
}
